// @flow
import { type EncType } from 'modules/enclave/types';
import {Map} from 'immutable';

// Enclave Groups
const groupLabels = Map({
  INTERNAL: 'My Enclaves',
  CLOSED_CONCRETE: 'Closed Source',
  OPEN: 'Open Source',
});

export const getGroupLabel = (labelName: EncType) => {
  return groupLabels.get(labelName) || 'Other Enclaves';
};


export const EXECUTE_SEARCH_AFTEWARDS = true;



// WEBPACK FOOTER //
// ./src/app/components/browse/Search2.0/search.constants.js